<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Pèlerinages" />
            <LesPelerinages />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesPelerinages from './LesPelerinages.vue';

export default {
    name: 'PelerinagePage',
    components: {
        NavBar,
        PageTitle,
        LesPelerinages,
        FooterComp,
    }
}
</script>